import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [
  { method: "GET", path: "", handlerName: "getByQuery" },
  { method: "GET", path: "/by-date", handlerName: "getByDate" },
  { method: "GET", path: "/by-caregiver", handlerName: "getByCaregiver" },
  { method: "GET", path: "/by-client", handlerName: "getByClient" },
  { method: "POST", path: "/clock-in", handlerName: "clockIn" },
  { method: "POST", path: "/clock-out", handlerName: "clockOut" },
  { method: "POST", path: "/approve", handlerName: "approveShift" },
  { method: "GET", path: "/mileage-allowance", handlerName: "getMileageAllowance" },
  { method: "POST", path: "/undo-approval", handlerName: "undoShiftApproval" },
  { method: "POST", path: "/approve-missed", handlerName: "approveMissedShift" },
  { method: "GET", path: "/history", handlerName: "getHistory" },
  { method: "GET", path: "/by-role", handlerName: "getByRole" },
  { method: "GET", path: "/current", handlerName: "getCurrent" },
  {
    method: "GET",
    path: "/caregiver-availability",
    handlerName: "getCaregiverAvailability",
  },
];

const baseService = createCrudService("shifts", customRoutes, router);

export const shiftsService = {
  ...baseService,

  updateCaregiver: async (shiftId, payload) => {
    return api.postCall(`/api/shifts/${shiftId}/caregivers`, payload);
  },

  updateClient: async (shiftId, payload) => {
    return api.postCall(`/api/shifts/${shiftId}/clients`, payload);
  },


  getShiftHistory: async (shiftId, occurrenceDate = null) => {
    const params = occurrenceDate ? { occurrenceDate } : {};
    return api.getCall(`/api/shifts/${shiftId}/history`, params);
  },

  getNoteAnswers: async (shiftId) => {
    return api.getCall(`/api/shifts/${shiftId}/note-answers`);
  },

  getApprovedShiftsByAuthorization: async (authorizationId) => {
    return api.getCall(`/api/shifts/by-authorization/${authorizationId}/approved`);
  },

  deleteWithDate: async (shiftId, date) => {
    const url = `/api/shifts/${shiftId}${date ? `?date=${date}` : ''}`;
    return api.deleteCall(url);
  },

  deleteFromDate: async (shiftId, date) => {
    const url = `/api/shifts/${shiftId}?date=${date}&deleteFromDate=true`;
    return api.deleteCall(url);
  },

  deleteEntireSeries: async (shiftId) => {
    const url = `/api/shifts/${shiftId}?deleteEntireSeries=true`;
    return api.deleteCall(url);
  },

  getStats: async (params) => {
    return api.getCall('/api/shifts/stats', params);
  },

  getExceptionShiftsInDateRange: async (recurringShiftId, startDate, endDate) => {
    return api.getCall(`/api/shifts/${recurringShiftId}/exception-shifts`, {
      startDate,
      endDate,
    });
  },

  handleExceptionShifts: async (payload) => {
    return api.postCall('/api/shifts/handle-exception-shifts', payload);
  },

  changeServiceCode: async (shiftId, payload) => {
    return api.putCall(`/api/shifts/${shiftId}/change-service-code`, payload);
  },

  startBreak: async (shiftId) => {
    return api.postCall(`/api/shifts/${shiftId}/breaks/start`, {});
  },

  endBreak: async (shiftId) => {
    return api.postCall(`/api/shifts/${shiftId}/breaks/end`, {});
  },

  markPickup: async (payload) => {
    return api.postCall('/api/shifts/mark-pickup', payload);
  },

  undoPickup: async (payload) => {
    return api.postCall('/api/shifts/undo-pickup', payload);
  },

  markDropoff: async (payload) => {
    return api.postCall('/api/shifts/mark-dropoff', payload);
  },

  updateClientEventTime: async (payload) => {
    return api.postCall('/api/shifts/update-client-event-time', payload);
  },

  completeShiftNotes: async (payload) => {
    return api.postCall('/api/shifts/complete-shift-notes', payload);
  },

  completeMedications: async (payload) => {
    return api.postCall('/api/shifts/complete-medications', payload);
  },

  markDidNotAttend: async (payload) => {
    return api.postCall('/api/shifts/mark-did-not-attend', payload);
  },

  getShiftTasks: async (shiftId) => {
    return api.getCall(`/api/shifts/${shiftId}/tasks`);
  },

  adminUpdateClientDetails: async (shiftId, payload) => {
    return api.postCall(`/api/shifts/${shiftId}/admin-update-client-details`, payload);
  },

  recheckAuth: async (shiftId) => {
    return api.postCall(`/api/shifts/${shiftId}/recheck-auth`, {});
  },

  adminClockOut: async (shiftId, payload) => {
    return api.postCall(`/api/shifts/${shiftId}/admin-clock-out`, payload);
  },

};
